import React from 'react'
import { Box, Typography, useTheme } from '@mui/material'
import { KeyStatType } from '../constants'
import { black, shade } from '../../../../colors'
import ReportsChip from '../ReportsChip'
import { type ICalculation } from '../../../../models/Report'

interface StatisticBoxProps {
  calculations: ICalculation[] | null | undefined
}

const statTypes = [
  KeyStatType.STANDARD_DEVIATION,
  KeyStatType.MEDIAN,
  KeyStatType.MODE
]

export const StatisticBox: React.FC<StatisticBoxProps> = ({ calculations }) => {
  const theme = useTheme()

  const wrapperStyle = {
    padding: theme.spacing(4),
    borderTop: `1px solid ${shade[650]}`,
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: {
      xs: 'space-evenly'
    },
    alignItems: 'center',
    color: theme.palette.text.secondary,
    mt: theme.spacing(6),
    gap: 4
  }

  // Filter and sort the statistics based on the desired order
  const showStats = calculations
    ?.filter((keyStatistic) => statTypes.includes(keyStatistic.name as KeyStatType))
    ?.sort((a, b) => statTypes.indexOf(a.name as KeyStatType) - statTypes.indexOf(b.name as KeyStatType))

  if (!showStats || showStats.length === 0) {
    return null
  }

  return (
    <Box sx={wrapperStyle}>
      {showStats?.map(({ name, values }) => (
        <Box
          key={name}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: theme.spacing(2)
          }}
        >
          <Typography fontWeight={600} color={black[100]}>
            {name}:
          </Typography>
          {values?.map((value, index) => (
            <ReportsChip
              key={index}
              index={index}
              label={!value ? 'N/A' : value}
            />
          ))}
        </Box>
      ))}
    </Box>
  )
}

export default StatisticBox
